export const MAX_CHILD_COUNT = 20;
